const localStorage = window.localStorage
const sessionStorage = window.sessionStorage

const getItem = (storage, key) => {
  let res = storage.getItem(key)
  try {
    let o = JSON.parse(decodeURIComponent(res))
    return o
  } catch (e) {
    return decodeURIComponent(res)
  }
}
const setItem = (storage, key, value) => {
  try {
    storage.setItem(key, encodeURIComponent(JSON.stringify(value)))
  } catch (e) {
    storage.clear()
    setItem(storage, key, value)
  }
}

export function getLocalStorage (key) { // 获取localStorage
  return getItem(localStorage, key)
}
export function setLocalStorage (key, value) { // 设置localStorage
  setItem(localStorage, key, value)
}
export function removeLocalStorage (key) { // 清除localStroage
  localStorage.removeItem(key)
}
export function clearLocalStorage () {
  localStorage.clear()
}
export function getSessionStorage (key) { // 获取sessionStorage
  return getItem(sessionStorage, key)
}
export function setSessionStorage (key, value) { // 设置sessionStorage
  setItem(sessionStorage, key, value)
}
export function removeSessionStorage (key) { // 清除sessionstroage
  sessionStorage.removeItem(key)
}
export function clearSessionStorage () {
  sessionStorage.clear()
}



// WEBPACK FOOTER //
// ./src/utils/storage.js